import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import utilities from './plugins/utilities'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import underscore from 'vue-underscore';
import VueSignaturePad from 'vue-signature-pad';
import ImageUploader from 'vue-image-upload-resize'
import VueQuagga from 'vue-quaggajs';
import QrcodeVue from 'qrcode.vue';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueBarcode from 'vue-barcode';
import format from 'vue-text-format';
import VueQrcodeReader from "vue-qrcode-reader";
import QuaggaScanner from 'vue-cc-quaggajs';


Vue.config.productionTip = false;

Vue.mixin(utilities);
Vue.use(underscore);
Vue.use(VueSignaturePad);
Vue.use(ImageUploader);
Vue.use(VueQuagga);
Vue.use(QrcodeVue);
Vue.use(QuaggaScanner);
Vue.use(VueBarcode);
Vue.use(format);
Vue.use(VueQrcodeReader);
Vue.component(VueCountdown.name, VueCountdown);


Vue.use(VueMoment, {
    moment,
})

Vue.filter('two_digits', (value) => {
    if (value < 0) {
        return '00';
    }
    if (value.toString().length <= 1) {
        return `0${value}`;
    }
    return value;
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')


